/* NQ.FI form conversion tracking.

   WHY IT IS SHAPED LIKE THIS
   GA4 (G-TQ07B27LSY) is delivered through Shopify's Web Pixels sandbox, not
   through the theme. There is no window.gtag and no window.dataLayer in theme
   scope, so calling gtag() from here would silently do nothing. The supported
   bridge is Shopify.analytics.publish(), which a Custom Pixel subscribes to
   and forwards to GA4. The matching pixel code lives in
   Settings > Customer events > Add custom pixel.

   WHY IT FIRES ON PAGE LOAD, NOT ON SUBMIT
   These are native Shopify contact forms doing a full page POST. A submit
   handler races the navigation and the event is often lost. Shopify redirects
   back to the same page with ?contact_posted=true, which only appears after a
   successful post, so that is the reliable signal.

   Each form gets its own event name for clarity in GA4.
   --------------------------------------------------------------------- */
(function () {
  'use strict';

  var FORMS = {
    '/pages/palaute-reklamaatio':  'nq_form_reklamaatio',
    '/pages/palaute-tuotepalaute': 'nq_form_tuotepalaute',
    '/pages/palaute-ideat':        'nq_form_ideat',
    '/pages/palaute-muu':          'nq_form_muu'
  };

  var path = location.pathname.replace(/\/+$/, '') || '/';
  // Drop any locale prefix, e.g. /en/pages/... so the map still matches.
  path = path.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');

  var eventName = FORMS[path];
  if (!eventName) return;

  var posted = /(^|[?&])contact_posted=true(&|$)/.test(location.search);
  var key = 'nq_ga4_sent:' + path;

  if (!posted) {
    // Back on the empty form: clear the guard so a second genuine submission
    // from the same session is counted.
    try { sessionStorage.removeItem(key); } catch (e) {}
    return;
  }

  // Reloading the confirmation URL must not count as another conversion.
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch (e) {}

  var payload = {
    form_name: eventName.replace('nq_form_', ''),
    form_id: eventName,
    page_path: path
  };

  try {
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish(eventName, payload);
    }
  } catch (e) {}

  // If a dataLayer ever does exist in theme scope (GTM added later), feed it
  // too. Harmless when absent.
  try {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: eventName, form_name: payload.form_name });
    }
  } catch (e) {}
})();
